import type { ComponentType } from 'react';
import type { Command } from '../../../menu/types';
import { DateRangeFilterRenderer } from './DateRangeFilterRenderer';
import { MonthFilterRenderer } from './MonthFilterRenderer';
import { WeekFilterRenderer } from './WeekFilterRenderer';
import { AdvancedDateRangeFilterRenderer } from './AdvancedDateRangeFilterRenderer';

export const DateFilterType = {
  DateRange: 'Date Range',
  Month: 'Month',
  Week: 'Week',
  Advanced: 'Advanced',
} as const;

export type DateFilterType = (typeof DateFilterType)[keyof typeof DateFilterType];

export type DateFilterRendererProps = {
  command: Command;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  initialDateRange?: { startDate?: string; endDate?: string };
};

type DateRangeFilterProps = DateFilterRendererProps;

const filterRenderers: Record<DateFilterType, ComponentType<DateFilterRendererProps>> = {
  [DateFilterType.DateRange]: DateRangeFilterRenderer,
  [DateFilterType.Month]: MonthFilterRenderer,
  [DateFilterType.Week]: WeekFilterRenderer,
  [DateFilterType.Advanced]: AdvancedDateRangeFilterRenderer,
};

export const DateRangeFilter = ({
  command,
  onDateRangeChange,
  initialDateRange,
}: DateRangeFilterProps) => {
  const filterType = command.dateFilter || DateFilterType.DateRange;
  const Renderer = filterRenderers[filterType as DateFilterType] ?? DateRangeFilterRenderer;
  return (
    <Renderer
      command={command}
      onDateRangeChange={onDateRangeChange}
      initialDateRange={initialDateRange}
    />
  );
};
